import DatabaseModel from './DatabaseModel.js';

// Alta/cambio y cierre manual de roles del item (colección items_roles).
var ItemRol = Object.create(DatabaseModel);

ItemRol.model = 'itemrol';

/** Alta o cambio manual de un rol. Devuelve la lista de roles actualizada del item. */
ItemRol.cambiar = function(payload) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/cambiar',
        method: 'POST',
        data: payload || {}
    }, false).then(function(res) {
        return (res && res.list) || [];
    });
};

/** Cierra (da de baja) un rol vigente. Devuelve la lista de roles actualizada del item. */
ItemRol.cerrar = function(idRol) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/cerrar/' + idRol,
        method: 'POST',
        data: {}
    }, false).then(function(res) {
        return (res && res.list) || [];
    });
};

export default ItemRol;
